import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";

export default class VendorInvoiceListController {
  constructor($scope) {
    const $ctrl = this;
    basicController($ctrl);
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.SinceStartDate = moment().format("MM/DD/YYYY");
    $ctrl.query = new AutoQuery({
      url: "QueryVendorInvoices.json",
      autoLoad: true,
      hideLeftNav: true,
      criteria: {
        orderNumber: $ctrl.orderId
      },
      sortOptions: {
        MfgInvoice: "Invoice #",
        "-MfgInvoice": "Invoice #",
        "PoNumber": "PO #",
        "-PoNumber": "PO #",
      },
      filters: [
        { groupBy: "Period", title: "Period" },
        { groupBy: "VendorName", title: "Vendor"},
        { groupBy: "SalesRepName", title: "Sales Rep"}
      ],
      pageSize: 12
    });
  }
  load() {
    const $ctrl = this;
    return $ctrl.query.load(true);
  }
}
